// extracted by mini-css-extract-plugin
export default {"richText":"RichTextView_richText__cfa9M"};